import { createAction, handleActions } from "redux-actions"
import produce from "immer";
import createRequestThunk from "../lib/createRequestThunk";
import i18n from "../locales/config";

import ConstData from "../lib/ConstData";
import { enTokenCMD, ctRcvKind, enMQType, ctBubbleKind } from "../lib/classTalk/CodeEnum";
import { ctActionType, ctMsgType, stCardType, stQnAItemType } from "../lib/ConstCommand";
import { checkDownloadableUrl } from "../lib/func/ExportFunction";

import {
    callEoForSendAction,
    callEoForSendWhisperAction
} from "../lib/EoBrowserSendUtil";

import {
    clear_download_files,
    get_download_file_list,
    upload_file
} from "../lib/api/file";

export const TALK_STATE_INIT                    = "classTalk/TALK_STATE_INIT";

export const APPEND_QUIZ_MESSAGE                = "classTalk/APPEND_QUIZ_MESSAGE";
export const APPEND_ALERT_MESSAGE_WITH_RESTAPI  = "classTalk/APPEND_ALERT_MESSAGE_WITH_RESTAPI";
export const APPEND_ALERT_MESSAGE               = "classTalk/APPEND_ALERT_MESSAGE";

const APPEND_SEND_MESSAGE                       = "classTalk/APPEND_SEND_MESSAGE";
const APPEND_SEND_AUDIO_MEMO                    = "classTalk/APPEND_SEND_AUDIO_MEMO";
const AUDIO_MEMO_SEND_FAILED                    = "classTalk/AUDIO_MEMO_SEND_FAILED"; // 20261015 음성메모 전송 실패 표시
const APPEND_SEND_INK_MEMO_FROM_HICLASS         = "classTalk/APPEND_SEND_INK_MEMO_FROM_HICLASS";
const APPEND_SEND_FILE_SHARE                    = "classTalk/APPEND_SEND_FILE_SHARE";
const APPEND_SEND_FILE_SHARE_SUCCESS            = "classTalk/APPEND_SEND_FILE_SHARE_SUCCESS";
const APPEND_SEND_FILE_SHARE_PROGRESS           = "classTalk/APPEND_SEND_FILE_SHARE_PROGRESS";
const APPEND_SEND_FILE_SHARE_FROM_HICLASS       = "classTalk/APPEND_SEND_FILE_SHARE_FROM_HICLASS";
const APPEND_RECEIVE_MESSAGE                    = "classTalk/APPEND_RECEIVE_MESSAGE";
const APPEND_MESSAGE_FROM_HICLASS               = "classTalk/APPEND_MESSAGE_FROM_HICLASS";
const APPEND_SEND_CONTENT                       = "classTalk/APPEND_SEND_CONTENT";
const UPDATE_CONTENT_SEND_STATUS                = "classTalk/UPDATE_CONTENT_SEND_STATUS";

export const appendSendMessage                  = createAction(APPEND_SEND_MESSAGE);
export const appendSendAudioMemo                = createAction(APPEND_SEND_AUDIO_MEMO);
export const audioMemoSendFailed                = createAction(AUDIO_MEMO_SEND_FAILED); // 20261015 음성메모 전송 실패 표시

// 20261015 음성메모 전송 실패 표시 - 메시지 식별용 ID 생성
const createAudioMemoId = () => "am" + Date.now().toString() + Math.floor(Math.random() * 100000).toString();

// 20261015 음성메모 전송 실패 표시 - 목록에서 해당 음성메모를 찾아 실패 상태로 변경 (immer draft 대상)
const markAudioMemoSendFailed = (msgList, memoId) => {
    if (!Array.isArray(msgList)) return;

    msgList.forEach(item => {
        const info = item && item.msgInfo;
        if (!info) return;

        if (info.memoId === memoId) {
            info.sendFailed = true;
        }

        // 귓속말 말풍선은 urlInfo 안에 음성메모 정보가 들어있음
        if (info.urlInfo && typeof info.urlInfo === "object" && info.urlInfo.memoId === memoId) {
            info.sendFailed = true;
            info.urlInfo.sendFailed = true;
        }
    });
};
export const appendSendInkMemoFromHiClass       = createAction(APPEND_SEND_INK_MEMO_FROM_HICLASS);
export const appendSendFileShare                = createAction(APPEND_SEND_FILE_SHARE);
//export const appendSendFileShare                = createRequestThunk(APPEND_SEND_FILE_SHARE, upload_file);
export const appendSendFileShareProgress        = createAction(APPEND_SEND_FILE_SHARE_PROGRESS);
export const appendSendFileShareFromHiClass     = createAction(APPEND_SEND_FILE_SHARE_FROM_HICLASS);
export const appendReceiveMessage               = createAction(APPEND_RECEIVE_MESSAGE);
export const appendMessageFromHiclass           = createAction(APPEND_MESSAGE_FROM_HICLASS);
export const appendSendContent                  = createAction(APPEND_SEND_CONTENT);
export const updateContentSendStatus            = createAction(UPDATE_CONTENT_SEND_STATUS);

const RECEIVE_QUIZ_ANSWER                       = "classTalk/RECEIVE_QUIZ_ANSWER";
const SET_PASS_POSSIBLE                         = "classTalk/SET_PASS_POSSIBLE";
const SHOW_QUIZ_RESPONSE_INFO                   = "classTalk/SHOW_QUIZ_RESPONSE_INFO";
const SHOW_QUIZ_RESPONSE_RESULT                 = "classTalk/SHOW_QUIZ_RESPONSE_RESULT";
const QUIZ_RESPONSE_FINISH                      = "classTalk/QUIZ_RESPONSE_FINISH";

const GET_DOWNLOAD_FILE_LIST                    = "classTalk/GET_DOWNLOAD_FILE_LIST";
const GET_DOWNLOAD_FILE_LIST_SUCCESS            = "classTalk/GET_DOWNLOAD_FILE_LIST_SUCCESS";
const RECEIVE_DOWNLOAD_FILE_ACTION_RESULT       = "classTalk/RECEIVE_DOWNLOAD_FILE_ACTION_RESULT";
const CLEAR_DOWNLOAD_FILES                      = "classTalk/CLEAR_DOWNLOAD_FILES";
const CLEAR_DOWNLOAD_FILES_SUCCESS              = "classTalk/CLEAR_DOWNLOAD_FILES_SUCCESS";

export const receiveQuizAnswer                  = createAction(RECEIVE_QUIZ_ANSWER);
export const setPassPossible                    = createAction(SET_PASS_POSSIBLE);
export const showQuizResponseInfo               = createAction(SHOW_QUIZ_RESPONSE_INFO);
export const showQuizResponseResult             = createAction(SHOW_QUIZ_RESPONSE_RESULT);
export const quizResponseFinish                 = createAction(QUIZ_RESPONSE_FINISH);

export const getDownloadFileList                = createRequestThunk(GET_DOWNLOAD_FILE_LIST, get_download_file_list);
export const rcvDownloadFileActionResult        = createAction(RECEIVE_DOWNLOAD_FILE_ACTION_RESULT);
export const clearDownloadFiles                 = createRequestThunk(CLEAR_DOWNLOAD_FILES, clear_download_files);

const EMOTICON_TOGGLE_OPENED                    = "classTalk/EMOTICON_TOGGLE_OPENED";
const EMOTICON_SELECTED_CANCEL                  = "classTalk/EMOTICON_SELECT_CANCEL";
const SELECT_EMOTICON_SEQ                       = "classTalk/SELECT_EMOTICON_SEQ";

const ADD_FUNCTION_TOGGLE_OPENED                = "classTalk/ADD_FUNCTION_TOGGLE_OPENED";
const SELECT_FUNCTION_SEQ                       = "classTalk/SELECT_FUNCTION_SEQ";

export const emoticonSelectedToggle             = createAction(EMOTICON_TOGGLE_OPENED);
export const emoticonSelectedCancel             = createAction(EMOTICON_SELECTED_CANCEL);
export const selectEmoticonSeq                  = createAction(SELECT_EMOTICON_SEQ);

export const addFunctionOpenedToggle            = createAction(ADD_FUNCTION_TOGGLE_OPENED);
export const selectFunctionSeq                  = createAction(SELECT_FUNCTION_SEQ);

// function menu
const VOICE_MEMO_TOGGLE_CLOSED                  = "classTalk/VOICE_MEMO_TOGGLE_CLOSED";
const INK_MEMO_TOGGLE_OPENED                    = "classTalk/INK_MEMO_TOGGLE_OPENED";

const FILE_SHARE_TOGGLE                         = "classTalk/FILE_SHARE_TOGGLE";
const FILE_OPEN_TOGGLE                          = "classTalk/FILE_OPEN_TOGGLE";
const FILE_DIR_REMOVE_TOGGLE                    = "classTalk/FILE_DIR_REMOVE_TOGGLE";
const FILE_ACTION_RESULT                        = "classTalk/FILE_ACTION_RESULT";
const UPDATE_FILE_DOWNLOADING                   = "classTalk/UPDATE_FILE_DOWNLOADING";
const UPDATE_FILE_DOWNLOADING_FOR_DIR           = "classTalk/UPDATE_FILE_DOWNLOADING_FOR_DIR";

const OPEN_CONTENT_SEND_PANEL                   = "classTalkLive/OPEN_CONTENT_SEND_PANEL";
const CLOSE_CONTENT_SEND_PANEL                  = "classTalkLive/CLOSE_CONTENT_SEND_PANEL";

export const voiceMemoClosedToggle              = createAction(VOICE_MEMO_TOGGLE_CLOSED);
export const inkMemoOpenedToggle                = createAction(INK_MEMO_TOGGLE_OPENED);

export const fileShareToggle                    = createAction(FILE_SHARE_TOGGLE);
export const fileOpenToggle                     = createAction(FILE_OPEN_TOGGLE);
export const fileDirRemoveToggle                = createAction(FILE_DIR_REMOVE_TOGGLE);
export const fileActionResult                   = createAction(FILE_ACTION_RESULT);
export const updateFileDownloading              = createAction(UPDATE_FILE_DOWNLOADING);
export const updateFileDownloadingForDir        = createAction(UPDATE_FILE_DOWNLOADING_FOR_DIR);

export const openContentSendPanel               = createAction(OPEN_CONTENT_SEND_PANEL);
export const closeContentSendPanel              = createAction(CLOSE_CONTENT_SEND_PANEL);

const IMG_THUMBNAIL_CLICK                       = "classTalk/IMG_THUMBNAIL_CLICK";

export const imgThumbnailClick                  = createAction(IMG_THUMBNAIL_CLICK);

export const CLOSE_CLASSTALK_MENU_MODAL         = "calssTalk/CLOSE_CLASSTALK_MENU_MODAL";

export const closeClasstalkMenuModal            = createAction(CLOSE_CLASSTALK_MENU_MODAL);

const initialState = {
    isEmoticonSelected          : false,
    selectedEmoticonSeq         : -1,
    selectedFunctionSeq         : -1,
    isAudioOpened               : false,
    audioStatus                 : "STOPED",
    
    isAddFunctionOpened         : false,
    isInkMemoOpened             : false, // ink memo 창

    isQuizWindowOpened          : false, // Quiz 창
    isQuizResponseInfoOpened    : false,
    isQuizResponseResultOpened  : false,

    isFileDirRemoveModalOpened  : false,
    isFileDownloadingNow        : false,

    responseInfo                : "",

    receivedMsg                 : [],
    whisperMsg                  : [],
    // 20260908 추가: 말풍선 생성 전에 도착한 콘텐츠 ACK를 contentSeq별로 보관한다.
    pendingContentSendStatuses  : {},

    isProgressBarShow           : false,
    progressCount               : 0,
    
    isInkOn                     : false,    // footer menu
};

const classTalk = handleActions({
    [TALK_STATE_INIT]: (state, action) => {
        return {
            ...state,
            isEmoticonSelected          : false,
            selectedEmoticonSeq         : -1,
            selectedFunctionSeq         : -1,
            isAudioOpened               : false,
            audioStatus                 : "STOPED",

            isAddFunctionOpened         : false,
            isInkMemoOpened             : false, // ink memo 창

            isQuizWindowOpened          : false, // Quiz 창
            isQuizResponseInfoOpened    : false,
            isQuizResponseResultOpened  : false,

            responseInfo                : "",

            receivedMsg                 : [],
            whisperMsg                  : [],

            isInkOn                     : false,    // footer menu
        }
    },

    // ======================================================= Quiz / Card
    [APPEND_QUIZ_MESSAGE]: (state, action) => {
        const { nextPhaseData } = action.payload;
        const { msgText, information, userNickname } = nextPhaseData;
        console.log("APPEND_QUIZ_MESSAGE - ", action.payload);

        callEoForSendAction("quiz", {
            kind        : "quiz",
            action      : "sendQuizInfo",
            information : { ...information, msgIndex: state.receivedMsg.length },
            userNickname
        }, "");

        if (msgText !== undefined && msgText !== null && msgText !== "") {
            return produce (state, draft => {
                draft.receivedMsg = draft.receivedMsg.concat(msgText);
            });
        } else {
            return {
                ...state
            }
        }
    },

    [RECEIVE_QUIZ_ANSWER]: (state, action) => {
        const { quiz_info, userSeq } = action.payload;
        console.log("RECEIVE_QUIZ_ANSWER - ", action.payload);

        return produce (state, draft => {
            const dialog = draft.receivedMsg[quiz_info.msgIndex];
            if (dialog && dialog.kind === ctBubbleKind.SendMsg && dialog.msgInfo.kind === stCardType.Quiz && dialog.msgInfo.cardInfo.seq === quiz_info.cardSeq) {
                const card_info = dialog.msgInfo.cardInfo;

                if (card_info && card_info.response) {
                    const response_info = card_info.response.find(info => info.userSeq === userSeq);
                    
                    if (!response_info) {
                        let response = {
                            userSeq,
                            answer: quiz_info.answer
                        }

                        card_info.response.push(response);
                    } else {
                        console.log("이미 response가 있음 - ", response_info);
                    }
                }
            }
        });
    },

    [SET_PASS_POSSIBLE]: (state, action) => {
        const { data } = action.payload;
        const { cardCode } = data;
        console.log("SET_PASS_POSSIBLE - ", action.payload);

        return produce (state, draft => {
            const msg_info = draft.receivedMsg.find(info => info.kind === ctBubbleKind.RcvMsg && info.msgInfo.kind === "card_template" && info.msgInfo.cardInfo.code === cardCode && info.msgInfo.cardInfo.isCurrent);
            if (msg_info) {
                const card_info = msg_info.msgInfo.cardInfo;
                if (card_info && card_info.isCurrent) {
                    card_info.isPossiblePass = true;
                }
            }
        });
    },

    [SHOW_QUIZ_RESPONSE_INFO]: (state, action) => {
        const { idx } = action.payload;
        console.log("SHOW_QUIZ_RESPONSE_INFO - ", action.payload);

        if (state.receivedMsg[idx].msgInfo.kind === ctMsgType.Quiz) {
            let card_info = state.receivedMsg[idx].msgInfo.cardInfo;
            
            if (card_info.type === stCardType.Quiz) {
                let quiz_info = card_info.data;

                if (quiz_info.data[0].type === stQnAItemType.Question) {
                    let isShortForm = quiz_info.data[0].exYN === "Y" ? false : true;

                    let response_info = card_info.response;
                    if (!isShortForm) {                // 객관식
                        let list_example = "";

                        if (quiz_info.data[2].type === stQnAItemType.Example) {
                            list_example = quiz_info.data[2].data.map(({ kind, type, data, ...rest }) => rest);

                            response_info.forEach(info => {
                                list_example.forEach(ex => {
                                    if (info.answer.no === ex.no) {
                                        if (ex.count) ex.count++;
                                        else ex.count = 1;
                                    } else {
                                        if (!ex.count) ex.count = 0;
                                    }
                                });
                            });
                        }

                        return {
                            ...state,
                            isQuizResponseInfoOpened : true,
                            responseInfo : {
                                idx,
                                quiz_info,
                                list_example,
                                list_targetMember: card_info.list_member,
                                responseCount: response_info.length
                            }
                        }
                    } else {                        // 주관식
                        return {
                            ...state,
                            isQuizResponseInfoOpened : true,
                            responseInfo : {
                                idx,
                                quiz_info,
                                list_targetMember: card_info.list_member,
                                responseCount: response_info.length,
                            }
                        }
                    }
                } 
            }
        }

        console.log("SHOW_QUIZ_RESPONSE_INFO - err) 예기치 못한 상황");
        return {
            ...state,
        }
    },

    [SHOW_QUIZ_RESPONSE_RESULT]: (state, action) => {
        const { idx } = action.payload;
        console.log("SHOW_QUIZ_RESPONSE_RESULT - ", action.payload);

        if (state.receivedMsg[idx].msgInfo.kind === ctMsgType.Quiz) {
            let card_info = state.receivedMsg[idx].msgInfo.cardInfo;
            //console.log(card_info);

            if (card_info.type === stCardType.Quiz) {
                let quiz_info = card_info.data;
                if (quiz_info.data[0].type === stQnAItemType.Question) {

                    return {
                        ...state,
                        responseInfo : {
                            quiz_info,
                            list_targetMember: card_info.list_member,
                            response : card_info.response
                        },
                        isQuizResponseInfoOpened : false,
                        isQuizResponseResultOpened : true
                    }
                } else {
                    return {
                        ...state,
                        responseInfo : "",
                        list_targetMember: card_info.list_member,
                        isQuizResponseInfoOpened : false,
                        isQuizResponseResultOpened : true
                    }
                }
            }
        }

        return {
            ...state,
        }
    },

    [QUIZ_RESPONSE_FINISH]: (state, action) => {
        const { liveSeq, idx, quizSeq, userNickname, list_member } = action.payload;
        console.log("QUIZ_RESPONSE_FINISH - ", action.payload);

        callEoForSendAction("quiz", {
            kind        : "quiz",
            action      : "quizResponseFinish",
            information : { liveSeq, idx, quizSeq, list_member },
            userNickname
        }, "");

        /* return {
            state,
        } */

        return produce(state, draft => {
            console.log("idx - ", idx);
            const rcvMsg = draft.receivedMsg[idx];
            console.log("rcvMsg = draft.receivedMsg[idx] - ", draft.receivedMsg[idx]);
            if (rcvMsg !== undefined && rcvMsg !== null) {
                console.log("rcvMsg !== undefined && rcvMsg !== null");
                const msgInfo = rcvMsg.msgInfo;
                if (msgInfo !== undefined && msgInfo !== null) {
                    console.log("msgInfo !== undefined && msgInfo !== null");
                    const cardInfo = msgInfo.cardInfo;
                    console.log("const cardInfo = msgInfo.cardInfo");
                    if (cardInfo !== undefined && cardInfo !== null) {
                        console.log("cardInfo !== undefined && cardInfo !== null");
                        cardInfo.isFinishedQuiz = true;
                        console.log("cardInfo.isFinishedQuiz = true");
                    }
                }
            }
        });
    },

    [GET_DOWNLOAD_FILE_LIST_SUCCESS]: (state, action) => {
        const { teacherSeq, liveSeq } = action.parms;
        const { isSuccessed } = action.payload;
        console.log("GET_DOWNLOAD_FILE_LIST_SUCCESS - ", action.payload);

        if (isSuccessed) {
            const { list_files } = action.payload;

            if (list_files && list_files.length > 0) {
                let list_newFiles = list_files.map(row => {
                    if (!checkDownloadableUrl(row)) {
                        console.log("/download/ 포함되지 않은 url임 ... row url => ", row);
                        return ConstData.MAIN_HOST_ADD + ConstData.DOWNLOAD_DIR + row;
                    } else {
                        return row;
                    }
                    // return ConstData.DOWNLOAD_DIR + row;
                });

                console.log("list_newFiles => ", list_newFiles);

                const { list_member } = action.payload;

                if (list_member && list_member.length > 0) {
                    let clist_member = list_member.map(memRow => ({
                        userSeq           : memRow.USER_SEQ,
                        userNickname      : memRow.USER_NICKNAME,
                        userProfile       : memRow.USER_PROFILE,
                        profileImgUrl     : memRow.USER_PROFILE_IMG,
                    }));

                    console.log("clist_member => ", clist_member);

                    const actionData = {
                        list_fileURL: list_newFiles,
                        list_member: clist_member
                    };

                    // 여기서 c# 함수 호출하기!
                    callEoForSendAction("fileDownloadDir", actionData);
                }

                return {
                    ...state,
                    receivedMsg: state.receivedMsg.concat(
                        { 
                            kind    : ctBubbleKind.RcvInfo, 
                            msgInfo : { 
                                rcvKind     : ctRcvKind.infoPentalk,
                                //kind        : "file_share",
                                rcvName     : "Pentalk",
                                emoticSeq   : state.selectedEmoticonSeq,
                                text        : i18n.t("공유파일_다운로드_시작", { ns: "classTalk" }),
                                urlInfo     : ""
                            }
                        }
                    ),
                    isFileDownloadingNow    : true
                }
            } else {
                console.log("다운로드 가능한 파일 X");

                return {
                    ...state,
                    receivedMsg: state.receivedMsg.concat(
                        { 
                            kind    : ctBubbleKind.RcvInfo, 
                            msgInfo : { 
                                rcvKind     : ctRcvKind.infoPentalk,
                                rcvName     : "Pentalk",
                                emoticSeq   : state.selectedEmoticonSeq,
                                text        : i18n.t("공유파일_없음", { ns: "classTalk" }),
                                urlInfo     : ""
                            }
                        }
                    ),
                    isFileDownloadingNow    : false
                }
            }
        } else {
            return {
                ...state,
                receivedMsg: state.receivedMsg.concat(
                    { 
                        kind    : ctBubbleKind.RcvInfo, 
                        msgInfo : { 
                            rcvKind     : ctRcvKind.infoPentalk,
                            rcvName     : "Pentalk",
                            emoticSeq   : state.selectedEmoticonSeq,
                            text        : i18n.t("공유파일_다운로드_요청_실패", { ns: "classTalk" }),
                            urlInfo     : ""
                        }
                    }
                ),
                isFileDownloadingNow    : false
            }
        }
    },

    [RECEIVE_DOWNLOAD_FILE_ACTION_RESULT]: (state, action) => {
        const { actionKind } = action.payload;
        console.log("RECEIVE_DOWNLOAD_FILE_ACTION_RESULT - ", action.payload);

        if (actionKind === "fileDownloadFinish") {
            return {
                ...state,
                receivedMsg: state.receivedMsg.concat(
                    { 
                        kind    : ctBubbleKind.Info, 
                        msgInfo : { 
                            rcvKind     : ctRcvKind.rcvPentalk,
                            rcvName     : "Pentalk",
                            emoticSeq   : state.selectedEmoticonSeq,
                            text        : i18n.t("공유파일_다운로드_완료", { ns: "classTalk" }),
                            urlInfo     : ""
                        }
                    }
                ),
                isFileDownloadingNow    : false
            }
        } else if (actionKind === "fileDownloadCanceled") {
            return {
                ...state,
                receivedMsg: state.receivedMsg.concat(
                    { 
                        kind    : ctBubbleKind.Info, 
                        msgInfo : { 
                            rcvKind     : ctRcvKind.rcvPentalk,
                            rcvName     : "Pentalk",
                            emoticSeq   : state.selectedEmoticonSeq,
                            text        : i18n.t("공유파일_다운로드_취소", { ns: "classTalk" }),
                            urlInfo     : ""
                        }
                    }
                ),
                isFileDownloadingNow    : false
            }
        } else {
            return {
                ...state,
                isFileDownloadingNow    : false
            }
        }
    },

    [CLEAR_DOWNLOAD_FILES_SUCCESS]: (state, action) => {
        const { teacherSeq, liveSeq } = action.parms;
        const { isSuccessed } = action.payload;
        console.log("CLEAR_DOWNLOAD_FILES_SUCCESS - ", action.payload);

        if (isSuccessed) {
            const { isRemoveSuccess } = action.payload;

            if (isRemoveSuccess) {
                console.log("다운로드 폴더 삭제 완료");

                return {
                    ...state,
                    isFileDirRemoveModalOpened  : false,
                    receivedMsg: state.receivedMsg.concat(
                        { 
                            kind    : ctBubbleKind.Info, 
                            msgInfo : { 
                                rcvKind     : ctRcvKind.rcvPentalk,
                                rcvName     : "Pentalk",
                                emoticSeq   : state.selectedEmoticonSeq,
                                text        : i18n.t("공유파일_폴더_삭제_완료", { ns: "classTalk" }),
                                urlInfo     : ""
                            } 
                        }
                    ),
                }
            } else {
                console.log("다운로드 폴더 삭제 실패");

                return {
                    ...state,
                    isFileDirRemoveModalOpened  : false,
                    receivedMsg: state.receivedMsg.concat(
                        { 
                            kind    : ctBubbleKind.Info, 
                            msgInfo : { 
                                rcvKind     : ctRcvKind.rcvPentalk,
                                rcvName     : "Pentalk",
                                emoticSeq   : state.selectedEmoticonSeq,
                                text        : i18n.t("공유파일_폴더_삭제_실패", { ns: "classTalk" }),
                                urlInfo     : ""
                            } 
                        }
                    ),
                }
            }
        } else {
            return {
                ...state,
                isFileDirRemoveModalOpened  : false,
                receivedMsg: state.receivedMsg.concat(
                    { 
                        kind    : ctBubbleKind.Info, 
                        msgInfo : { 
                            rcvKind     : ctRcvKind.rcvPentalk,
                            rcvName     : "Pentalk",
                            emoticSeq   : state.selectedEmoticonSeq,
                            text        : i18n.t("공유파일_폴더_삭제_요청_실패", { ns: "classTalk" }),
                            urlInfo     : ""
                        } 
                    }
                ),
            }
        }
    },

    // ======================================================= ClassTalk

    [APPEND_SEND_MESSAGE]: (state, action) => {
        const { msgText, userNickname, memberSeqList } = action.payload;
        console.log("APPEND_SEND_MESSAGE - ", action.payload);

        let bubbleKind = ctBubbleKind.SendMsg;
        let rcvKind = ctRcvKind.Teacher;
        let newMsgInfo = {
            kind    : bubbleKind,
            msgInfo : { 
                rcvKind,
                text        : msgText, 
                emoticSeq   : state.selectedEmoticonSeq, 
                urlInfo     : ""
            }
        };

        if (memberSeqList !== undefined && memberSeqList !== null && memberSeqList.length > 0) {
            bubbleKind = ctBubbleKind.SendWhisper;
            rcvKind = ctRcvKind.sendWhisper;
            callEoForSendAction("message_talk", { text: msgText, emoticSeq: state.selectedEmoticonSeq, userNickname }, JSON.stringify(memberSeqList.map(info => info.userSeq)));

            return produce (state, draft => {
                memberSeqList.forEach(member => {
                    const whisper_info = draft.whisperMsg.find(info => info.stdSeq === member.userSeq);

                    if (whisper_info) {
                        whisper_info.msg.push(newMsgInfo);
                    } else {
                        draft.whisperMsg.push({
                            stdSeq      : member.userSeq,
                            stdNickname : member.userNickname,
                            profileImg  : member.profileImgUrl,
                            msg         : [newMsgInfo]
                        });
                    }
                });

                draft.receivedMsg     = draft.receivedMsg.concat({
                    kind        : bubbleKind,
                    msgInfo     : { 
                        rcvKind,
                        text        : msgText, 
                        emoticSeq   : state.selectedEmoticonSeq, 
                        urlInfo     : "" ,
                        data        : memberSeqList
                    }
                });
                draft.isEmoticonSelected  = false;
                draft.selectedEmoticonSeq = -1;
                draft.isAddFunctionOpened = false;
            });
        } else {
            callEoForSendAction("message_talk", { text: msgText, emoticSeq: state.selectedEmoticonSeq, userNickname }, "");

            return {
                ...state,
                receivedMsg     : state.receivedMsg.concat({
                    kind        : bubbleKind,
                    msgInfo     : { 
                        rcvKind     : rcvKind,
                        text        : msgText, 
                        emoticSeq   : state.selectedEmoticonSeq, 
                        urlInfo     : "" ,
                        data        : memberSeqList
                    }
                }),
                isEmoticonSelected  : false,
                selectedEmoticonSeq : -1,
                isAddFunctionOpened : false
            }
        }
    },

    [APPEND_SEND_AUDIO_MEMO]: (state, action) => {
        const { userNickname, userSeq, url, data, memberSeqList } = action.payload;
        console.log("APPEND_SEND_AUDIO_MEMO - ", action.payload);

        // 20261015 전송 실패 시 해당 말풍선에 실패 표시를 하기 위한 ID와 콜백
        const memoId = createAudioMemoId();
        const onFail = () => {
            if (window.hiclasstv && window.hiclasstv.store) {
                window.hiclasstv.store.dispatch(audioMemoSendFailed({ memoId }));
            }
        };

        let bubbleKind = ctBubbleKind.SendMsg;
        let rcvKind = ctRcvKind.Teacher;
        let newMsgInfo = {
            kind: bubbleKind,
            msgInfo: {
                rcvKind,
                kind: "audio_memo",
                text: i18n.t("음성메모", { ns: "classTalk" }),
                urlInfo: url,
                memoId  // 20261015 음성메모 식별 ID
            }
        };

        if (memberSeqList !== undefined && memberSeqList !== null && memberSeqList.length > 0) {
            bubbleKind = ctBubbleKind.SendWhisper;
            rcvKind = ctRcvKind.sendWhisper;
            callEoForSendAction("audio_memo", { voiceData: data, userSeq, userNickname, onFail }, JSON.stringify(memberSeqList.map(info => info.userSeq))); // 20261015 onFail 추가

            return produce (state, draft => {
                memberSeqList.forEach(member => {
                    const whisper_info = draft.whisperMsg.find(info => info.stdSeq === member.userSeq);

                    if (whisper_info) {
                        whisper_info.msg.push(newMsgInfo);
                    } else {
                        draft.whisperMsg.push({
                            stdSeq      : member.userSeq,
                            stdNickname : member.userNickname,
                            profileImg  : member.profileImgUrl,
                            msg         : [newMsgInfo]
                        });
                    }
                });

                draft.receivedMsg = draft.receivedMsg.concat({
                    kind: bubbleKind,
                    msgInfo: {
                        rcvKind,
                        kind: "audio_memo",
                        text: i18n.t("음성메모", { ns: "classTalk" }),
                        urlInfo: url,
                        data: memberSeqList,
                        memoId  // 20261015 음성메모 식별 ID
                    }
                });
                
                draft.isAudioOpened       = false;
                draft.isAddFunctionOpened = false;
            });
        } else {
            callEoForSendAction("audio_memo", { voiceData:data, userSeq, userNickname, onFail }, ""); // 20261015 onFail 추가
            
            return {
                ...state,
                receivedMsg         : state.receivedMsg.concat({
                    kind            : bubbleKind,
                    msgInfo         : { 
                        rcvKind,
                        kind        : "audio_memo", 
                        text        : i18n.t("음성메모", { ns: "classTalk" }), 
                        urlInfo     : url,
                        data        : memberSeqList,
                        memoId      // 20261015 음성메모 식별 ID
                    }
                }),
                isAudioOpened       : false,
                isAddFunctionOpened : false,
            }
        }
    },

    // 20261015 음성메모 전송 실패 시 해당 말풍선 실패 표시
    [AUDIO_MEMO_SEND_FAILED]: (state, action) => {
        const { memoId } = action.payload;
        console.log("AUDIO_MEMO_SEND_FAILED - ", memoId);

        return produce(state, draft => {
            markAudioMemoSendFailed(draft.receivedMsg, memoId);

            if (Array.isArray(draft.whisperMsg)) {
                draft.whisperMsg.forEach(whisper_info => markAudioMemoSendFailed(whisper_info.msg, memoId));
            }
        });
    },

    [APPEND_SEND_INK_MEMO_FROM_HICLASS]: (state, action) => {
        const { imgDataUrl, isWhisper, memberSeqList } = action.payload;
        console.log("APPEND_SEND_INK_MEMO_FROM_HICLASS - ", action.payload);

        let bubbleKind = ctBubbleKind.SendMsg;
        let rcvKind = ctRcvKind.Teacher;
        let msgInfo = {
            kind : bubbleKind,
            msgInfo : {
                rcvKind,
                kind: "ink_memo",
                text: i18n.t("잉크메모", { ns: "classTalk" }),
                urlInfo: imgDataUrl
            }
        };
        
        if (memberSeqList !== undefined && memberSeqList !== null && memberSeqList.length > 0) {
            bubbleKind = ctBubbleKind.SendWhisper;
            rcvKind = ctRcvKind.sendWhisper;

            return produce (state, draft => {
                memberSeqList.forEach(member => {
                    const whisper_info = draft.whisperMsg.find(info => info.stdSeq === Number(member.userSeq));

                    if (whisper_info) {
                        whisper_info.msg.push(msgInfo);
                    } else {
                        draft.whisperMsg.push({
                            stdSeq      : Number(member.userSeq),
                            stdNickname : member.userNickname,
                            profileImg  : member.profileImgUrl,
                            msg         : [msgInfo]
                        });
                    }
                });

                if (!isWhisper) {
                    draft.receivedMsg = draft.receivedMsg.concat({
                        kind: bubbleKind,
                        msgInfo: {
                            ...msgInfo,
                            data: memberSeqList,
                            rcvKind
                        }
                    });
                    draft.isInkMemoOpened = false;
                    draft.toolMode = "PEN";
                    draft.inkMemoFile = "";
                    draft.isAddFunctionOpened = false;
                }
            });
        } else {
            return {
                ...state,
                receivedMsg         : state.receivedMsg.concat(msgInfo),
                isInkMemoOpened     : false,
                toolMode            : "PEN",
                inkMemoFile         : "",
                isAddFunctionOpened : false
            }
        }
    },

    // Pentalk Browser에서 [파일공유] 클릭 시, C# 호출
    [APPEND_SEND_FILE_SHARE]: (state, action) => {
        const { mode, chatRoomSeq, teacherSeq, liveSeq, userSeq, userNickname, command, mixedClassStatus } = action.payload;

        const actionData = {
            mode,
            chatRoomSeq,
            teacherSeq,
            liveSeq,
            userSeq, 
            userNickname,
            command,
            mixedClassStatus
        }

        callEoForSendAction("file_share", actionData, "");

        return {
            ...state,
            isAddFunctionOpened : false,
        }
    },

    [APPEND_SEND_FILE_SHARE_PROGRESS]: (state, action) => {
        const { data } = action.payload;
        console.log("APPEND_SEND_FILE_SHARE_PROGRESS - ", data);

        return {
            ...state,
            isProgressBarShow   : data < 100,
            progressCount       : data
        }
    },

    [APPEND_SEND_FILE_SHARE_FROM_HICLASS]: (state, action) => {
        //const { filename } = action.parms;
        const { filename, isSuccessed } = action.payload;
        console.log("APPEND_SEND_FILE_SHARE_FROM_HICLASS - ", action.payload);

        if (isSuccessed) {
            const { isUploadSuccess } = action.payload;
            
            if (isUploadSuccess) {
                const { path } = action.payload;

                let downloadUrl = path;
                if (!checkDownloadableUrl(downloadUrl)) {
                    console.log("/download/ 포함되지 않은 url임 ... downloadUrl path => ", downloadUrl);
                    downloadUrl = ConstData.MAIN_HOST_ADD + ConstData.DOWNLOAD_DIR + path;
                }

                let bubbleKind = ctBubbleKind.SendMsg;
                let rcvKind = ctRcvKind.Teacher;
                let newMsgInfo = {
                    kind : bubbleKind,
                    msgInfo : {
                        rcvKind,
                        kind    : "file_share",
                        text    : filename + i18n.t("파일_전송_완료_알림", { ns: "classTalk" }),
                        urlInfo : downloadUrl
                    }
                };
                console.log("여기가 메인 브라우저 파일 전송 1111");

                return {
                    ...state,
                    receivedMsg         : state.receivedMsg.concat(newMsgInfo),
                    isProgressBarShow   : false,
                    progressCount       : 0
                }
            } else {
                console.log("isUploadSuccess is ", isUploadSuccess);
                return {
                    ...state,
                    isProgressBarShow   : false,
                    progressCount       : 0
                }
            }
        } else {
            console.log("isSuccessed is ",isSuccessed);
            return {
                ...state,
                isProgressBarShow   : false,
                progressCount       : 0
            }
        }
    },

    [APPEND_RECEIVE_MESSAGE]: (state, action) => {
        const msgInfo = action.payload;
        console.log("APPEND_RECEIVE_MESSAGE - ", action.payload);

        return {
            ...state,
            receivedMsg: state.receivedMsg.concat(
                { kind: ctBubbleKind.RcvMsg, msgInfo }
            )
        }
    }, 

    [APPEND_MESSAGE_FROM_HICLASS]: (state, action) => {
        const { msgInfo } = action.payload;
        console.log("APPEND_MESSAGE_FROM_HICLASS - ", action.payload);

        return {
            ...state,
            receivedMsg: state.receivedMsg.concat(msgInfo)
        }
    },

    [APPEND_SEND_CONTENT]: (state, action) => {
        const { action: contentAction, information, userNickname, receiveStudentSeq } = action.payload;
        console.log("APPEND_SEND_CONTENT - ", action.payload);

        return produce(state, draft => {
            const contentStatusKey = String(information?.contentSeq);
            const pendingStatuses = draft.pendingContentSendStatuses[contentStatusKey] || {};
            draft.receivedMsg.push({
                kind: ctBubbleKind.SendMsg,
                msgInfo: {
                    rcvKind: ctRcvKind.ContentSend,
                    action: contentAction,    // "url-start" | "app-start" | "file-start" | "message-start"
                    information,              // { url, faviconUrl, contentSeq, contentTeacherSeq, refContentSeq, ... } 원본 구조 그대로
                    userNickname,
                    // receiveStudentSeq: seq 배열 → 상세 객체 배열로 변환해서 저장
                    // 이후 UPDATE_CONTENT_SEND_STATUS에서 각 항목의 status/isReceived 갱신
                    receiveStudentSeq: (receiveStudentSeq || []).map(m => ({
                        userSeq     : String(m.userSeq),
                        userNickname: m.userNickname,
                        isReceived  : Object.prototype.hasOwnProperty.call(pendingStatuses, String(m.userSeq)),
                        status      : Object.prototype.hasOwnProperty.call(pendingStatuses, String(m.userSeq)) ? pendingStatuses[String(m.userSeq)] : null,
                    })),
                }
            });
            // 20260908 추가: 생성된 말풍선에 반영했으므로 대기 ACK는 제거한다.
            delete draft.pendingContentSendStatuses[contentStatusKey];
        });
    },

    [UPDATE_CONTENT_SEND_STATUS]: (state, action) => {
        const { contentSeq, userSeq, status } = action.payload;
        console.log("UPDATE_CONTENT_SEND_STATUS - payload => ", action.payload);
        // contentSeq: 어떤 전송 건인지 식별
        // userSeq: 누가 수신 확인했는지

        return produce(state, draft => {
            // receivedMsg 전체를 순회하며 해당 contentSeq의 말풍선을 찾음
            const targetMsg = draft.receivedMsg.find(
                msg =>
                    msg.kind === ctBubbleKind.SendMsg &&
                    msg.msgInfo.rcvKind === ctRcvKind.ContentSend &&
                    // ✅ APPEND_SEND_CONTENT에서 contentSeq는 information 안에 저장됨
                    // msgInfo.contentSeq (X) → msgInfo.information.contentSeq (O)
                    String(msg.msgInfo.information?.contentSeq) === String(contentSeq)
            );

            if (targetMsg) {
                // receiveStudentSeq 배열에서 해당 학생 항목 갱신
                const member = targetMsg.msgInfo.receiveStudentSeq.find(
                    m => String(m.userSeq) === String(userSeq)
                );
                if (member) {
                    // member.isReceived = status === "received"; // "not_support" 또는 "permission_denied"이면 isReceived = false, "received"이면 isReceived = true
                    member.isReceived = status !== null; // null이면 isReceived = false, 그 외의 경우 isReceived = true ("received" | "executed" | "not_installed" | "downloaded" | "not_support" | "permission_denied" | "invalid_payload")
                    member.status = status;
                }
            } else {
                // 20260908 추가: 업로드 완료 말풍선보다 ACK가 먼저 도착해도 수신 상태를 잃지 않는다.
                const contentStatusKey = String(contentSeq);
                if (!draft.pendingContentSendStatuses[contentStatusKey]) {
                    draft.pendingContentSendStatuses[contentStatusKey] = {};
                }
                draft.pendingContentSendStatuses[contentStatusKey][String(userSeq)] = status;
            }
        });
    },

    [APPEND_ALERT_MESSAGE_WITH_RESTAPI]: (state, action) => {
        const { msgText } = action.parms;
        console.log("APPEND_ALERT_MESSAGE_WITH_RESTAPI - ", action.parms);

        return {
            ...state,
            receivedMsg: state.receivedMsg.concat(
                { 
                    kind    : ctBubbleKind.Info, 
                    msgInfo : { 
                        rcvKind     : ctRcvKind.rcvPentalk,
                        rcvName     : "Pentalk",
                        emoticSeq   : state.selectedEmoticonSeq,
                        text        : msgText,
                        urlInfo     : ""
                    } 
                }
            ),
            isEmoticonSelected : false,
            selectedEmoticonSeq : -1,
            isAddFunctionOpened : false,
        }
    },

    [APPEND_ALERT_MESSAGE]: (state, action) => {
        const msgText = action.payload;
        console.log("APPEND_ALERT_MESSAGE - chat => ", action.payload);

        return {
            ...state,
            receivedMsg: state.receivedMsg.concat(
                { 
                    kind    : ctBubbleKind.Info, 
                    msgInfo : { 
                        rcvKind     : ctRcvKind.rcvPentalk,
                        rcvName     : "Pentalk",
                        emoticSeq   : state.selectedEmoticonSeq,
                        text        : msgText,
                        urlInfo     : ""
                    } 
                }
            ),
            isEmoticonSelected : false,
            selectedEmoticonSeq : -1,
            isAddFunctionOpened : false,
        }
    },

    [EMOTICON_TOGGLE_OPENED]: (state, action) => {
        return {
            ...state,
            isEmoticonSelected  : !state.isEmoticonSelected,
            selectedEmoticonSeq : -1,
            isAddFunctionOpened : false,
        }
    },

    [EMOTICON_SELECTED_CANCEL]: (state, action) => {
        return {
            ...state,
            selectedEmoticonSeq : -1,
            isAddFunctionOpened : false,
        }
    },

    [SELECT_EMOTICON_SEQ]: (state, action) => {
        const selectedEmoticonSeq = action.payload;

        return {
            ...state,
            isEmoticonSelected  : false,
            selectedEmoticonSeq : selectedEmoticonSeq,
            isAddFunctionOpened : false,
        }
    },

    [SELECT_FUNCTION_SEQ]: (state, action) => {
        //const selectedFunctionSeq = action.payload;
        const { func, chatRoomSeq, userSeq, userNickname, mode, memberSeqList } = action.payload;
        console.log("SELECT_FUNCTION_SEQ - ", action.payload);

        let preSelectedFuncSeq = state.selectedFunctionSeq;
        let preQuizWindowOpenedStatus = state.isQuizWindowOpened;
        
        if (func === ctActionType.InkMemo) {
            const actionData = {
                userNickname,
                userSeq,
                command     : enTokenCMD.chat_Memo,
                isWhisper   : false
            }

            if (memberSeqList !== undefined && memberSeqList !== null && memberSeqList.length > 0) {
                //callEoForSendAction("memoTalk", actionData, JSON.stringify(memberSeqList.map(info => info.userSeq)));
                callEoForSendAction("memoTalk", actionData, JSON.stringify(memberSeqList));
            } else {
                callEoForSendAction("memoTalk", actionData, "");
            }

        } else if (func === ctActionType.FileShare) {
            
        } else if (func === ctActionType.PullScreen) {
            const actionData = {
                mode,
                chatRoomSeq,
                userNickname,
                teacherSeq  : userSeq,
                userSeq     : 0,
                command     : enTokenCMD.page_GetArtifact,
                restAPIURL  : ConstData.REST_API_HOST_ADD + "/upload"
            }

            callEoForSendAction("getArtifact", actionData);
        } else if (func === ctActionType.Quiz) {
            preQuizWindowOpenedStatus = !state.isQuizWindowOpened;
        } 

        return {
            ...state,
            selectedFunctionSeq     : preSelectedFuncSeq,
            isEmoticonSelected      : false,
            selectedEmoticonSeq     : -1,
            isAddFunctionOpened     : false,
            isAudioOpened           : func === ctActionType.VoiceMemo,
            isQuizWindowOpened      : preQuizWindowOpenedStatus
        }
    },

    [ADD_FUNCTION_TOGGLE_OPENED]: (state, action) => {
        return {
            ...state,
            isEmoticonSelected      : false,
            selectedEmoticonSeq     : -1,
            isAddFunctionOpened     : !state.isAddFunctionOpened
        }
    },

    // 음성톡
    [VOICE_MEMO_TOGGLE_CLOSED]: (state, action) => {
        return {
            ...state,
            isAudioOpened : false
        }
    },

    // 메모톡
    [INK_MEMO_TOGGLE_OPENED]: (state, action) => {
        const {selectedFunc, userNickname, userSeq } = action.payload;
        console.log("INK_MEMO_TOGGLE_OPENED : ", selectedFunc);

        if(selectedFunc !== undefined && selectedFunc !== null) { // ink memo 말풍선 클릭한 경우
            const { imgUrl } = action.payload;
            const actionData = {
                userNickname,
                userSeq,
                command     : enTokenCMD.chat_Memo,
                inkURL      : imgUrl,
                isWhisper   : false
            }

            callEoForSendAction("inkMemo", actionData, "");

            return {
                ...state
            }
        } else { 
            console.log("이런경우가 있나..?");
            
            return {
                ...state
            }
        }
    },

    [FILE_SHARE_TOGGLE]: (state, action) => {
        const { fileURL, originalFileName, idx } = action.payload;
        console.log(`FILE_SHARE_TOGGLE - idx[${idx}], fileURL[${fileURL}], originalFileName[${originalFileName}]`);

        // 20260714 수정: originalFileName(말풍선 표시용 원본 파일명)을 저장/오픈 경로 파일명으로 쓰면,
        // 실제 서버(fileURL)에 저장된 파일명과 달라져서 C#에서 로컬로 저장한 파일명과
        // "파일열기" 시 찾으려는 파일명이 서로 어긋나 "File not found"가 발생함.
        // 로컬 저장(doTools_FileShare)과 파일열기(doTools_FileOpen) 양쪽 모두 항상 fileURL의
        // 실제 파일명을 기준으로 동일하게 계산되도록 originalFileName 우선 사용을 제거함 ... by hjkim
        const filename = fileURL.substr(fileURL.lastIndexOf("/") + 1);
        console.log("final filename => ", filename);

        const actionData = {
            fileURL,
            filename,
            idx
        };

        callEoForSendAction("fileShare", actionData);

        return {
            ...state,
        }
    },

    [FILE_OPEN_TOGGLE]: (state, action) => {
        const { fileURL, originalFileName, fileType } = action.payload;
        console.log(`FILE_OPEN_TOGGLE - fileType[${fileType}], fileURL[${fileURL}], originalFileName[${originalFileName}]`);

        // 20260714 수정: FILE_SHARE_TOGGLE(다운로드/저장 시)과 동일하게 fileURL 기준으로 파일명을
        // 계산해야 실제 로컬에 저장된 파일명과 일치하여 "파일열기"가 정상 동작함 ... by hjkim
        const filename = fileURL.substr(fileURL.lastIndexOf("/") + 1);
        console.log("final filename => ", filename);

        const actionData = {
            filename,
            fileType
        };

        callEoForSendAction("fileOpen", actionData);

        return {
            ...state,
        }
    },

    [FILE_DIR_REMOVE_TOGGLE]: (state, action) => {
        const { isModalOpened } = action.payload;
        console.log(`FILE_DIR_REMOVE_TOGGLE - isModalOpened[${isModalOpened}]`);

        return {
            ...state,
            isFileDirRemoveModalOpened  : isModalOpened
        }
    },

    [FILE_ACTION_RESULT]: (state, action) => {
        const { idx } = action.payload;
        console.log("FILE_ACTION_RESULT - ", idx);

        return produce(state, draft => {
            const rcvMsg = draft.receivedMsg[idx];
            if (rcvMsg !== undefined && rcvMsg !== null) {
                if (rcvMsg.msgInfo !== undefined && rcvMsg.msgInfo !== null) {
                    rcvMsg.msgInfo.isDownloading = false;
                    rcvMsg.msgInfo.isDownloaded = true;
                    //rcvMsg.msgInfo.downUrlInfo = fileURL;
                    const fileURL = rcvMsg.msgInfo.urlInfo;

                    const ext = fileURL.substring(fileURL.lastIndexOf("."), fileURL.length);
                    switch (ext) {
                        case ".mp4":
                        case ".wmv":
                            rcvMsg.msgInfo.type = enMQType.Video;
                            break;

                        case ".mp3":
                        case ".wma":
                            rcvMsg.msgInfo.type = enMQType.Audio;
                            break;

                        case ".im3":
                            rcvMsg.msgInfo.type = enMQType.InkMedia;
                            break;

                        default:
                            rcvMsg.msgInfo.type = enMQType.Files;
                            break;
                    }
                    
                    rcvMsg.msgInfo.text = i18n.t("파일_다운로드_완료_알림", { ns: "classTalk" });
                }
            }
        });
    },

    [UPDATE_FILE_DOWNLOADING]: (state, action) => {
        const { idx, progress } = action.payload;
        console.log("UPDATE_FILE_DOWNLOADING");

        return produce(state, draft => {
            const rcvMsg = draft.receivedMsg[idx];
            if (rcvMsg !== undefined && rcvMsg !== null) {
                if (rcvMsg.msgInfo !== undefined && rcvMsg.msgInfo !== null) {
                    rcvMsg.msgInfo.isDownloading = true;
                    rcvMsg.msgInfo.isDownloaded = false;
                    rcvMsg.msgInfo.kind = "file_share"; // change kind
                    //rcvMsg.msgInfo.text = i18n.t("파일_다운로드_중_알림", { ns: "classTalk" });
                    rcvMsg.msgInfo.progress = progress;
                }
            }
        });
    },

    [UPDATE_FILE_DOWNLOADING_FOR_DIR]: (state, action) => {
        const { progress } = action.payload;
        console.log("UPDATE_FILE_DOWNLOADING_FOR_DIR - progress => ", progress);

        return produce(state, draft => {
            const idx = draft.receivedMsg.length - 1;
            const rcvMsg = draft.receivedMsg[idx];
            if (rcvMsg !== undefined && rcvMsg !== null) {
                if (rcvMsg.msgInfo !== undefined && rcvMsg.msgInfo !== null) {
                    rcvMsg.msgInfo.isDownloading = true;
                    rcvMsg.msgInfo.isDownloaded = false;
                    if (rcvMsg.msgInfo.kind !== "file_share") rcvMsg.msgInfo.kind = "file_share"; // change kind
                    //rcvMsg.msgInfo.text = i18n.t("파일_다운로드_중_알림", { ns: "classTalk" });
                    rcvMsg.msgInfo.progress = progress;
                }
            }
        });
    },

    [OPEN_CONTENT_SEND_PANEL]: (state, action) => {
        const { msgInfo, source, mode, memberSeq } = action.payload;
        console.log("OPEN_CONTENT_SEND_PANEL - msgInfo => ", msgInfo);

        if (msgInfo === undefined || msgInfo === null) {
            callEoForSendAction("contentSendPanel", {
                action: "open",
                source,
                mode,
                memberSeq
            });

            return { ...state };
        }

        const { action: msgAction, information, receiveStudentSeq, userNickname } = msgInfo;

        // C#에 패널 열기 + 표시할 데이터 전달
        // receiveStudentSeq 안에 이미 { userSeq, userNickname, isSent, isReceived, status }
        // 갱신된 최신 상태 그대로 C#에 전달
        callEoForSendAction("contentSendPanel", {
            // action: "open",
            // msgAction,   // "url-start" | "app-start" | "file-upload" | "message"
            action: msgAction,   // "url-start" | "app-start" | "file-upload" | "message"
            information, // { url, faviconUrl, contentSeq, contentTeacherSeq, refContentSeq, ... } 원본 구조 그대로
            userNickname,
            receiveStudentSeq, // { userSeq, userNickname, isReceived, status }
            source,
            mode,
            memberSeq
        });

        /* callEoForSendAction("contentSendPanel", {
            action: "open",
            contentType: msgInfo.contentType,
            contentSeq: msgInfo.contentSeq,
            contentTeacherSeq: msgInfo.contentTeacherSeq,
            refContentSeq: msgInfo.refContentSeq,
            // 콘텐츠 상세
            urlInfo: msgInfo.urlInfo,
            urlFavicon: msgInfo.urlFavicon,
            appSeq: msgInfo.appSeq,
            appTitle: msgInfo.appTitle,
            text: msgInfo.text,
            originalFileName: msgInfo.originalFileName,
            // 수신 현황 목록 (C#에서 memberList를 표시하는 데 사용)
            memberList: msgInfo.memberList,
        }); */

        return { ...state };
    },

    [CLOSE_CONTENT_SEND_PANEL]: (state) => {
        // C#에 패널 닫기 신호 전달
        callEoForSendAction("contentSendPanel", {
            action: "close",
        });

        return { ...state };
    },

    [IMG_THUMBNAIL_CLICK]: (state, action) => {
        const { imgDataUrl, idx } = action.payload;
        const { receivedMsg } = state;
        console.log("IMG_THUMBNAIL_CLICK - msg idx => ", idx);

        const rcvMsg = receivedMsg[idx];
        if (rcvMsg !== undefined && rcvMsg !== null) {
            console.log("rcvMsg is not null");
            if (rcvMsg.msgInfo !== undefined && rcvMsg.msgInfo !== null) {
                const userSeq = rcvMsg.msgInfo.rcvUserSeq;
                const userNickname = rcvMsg.msgInfo.rcvName;
                console.log("rcvMsg rcvUserSeq => ", userSeq);
                console.log("rcvMsg rcvName => ", userNickname);

                const actionData = {
                    userSeq,
                    userNickname,
                    imgDataUrl
                };
    
                callEoForSendAction("showImage", actionData);
            }
        }

        return {
            ...state,
        }
    },

    [CLOSE_CLASSTALK_MENU_MODAL]: (state, action) => {
        return {
            ...state,
            selectFunctionSeq           : -1,
            isEmoticonSelected          : false,
            selectEmoticonSeq           : -1,
            isAddFunctionOpened         : false,
            isAudioOpened               : false,
            isQuizWindowOpened          : false,
            isQuizResponseInfoOpened    : false,
            isQuizResponseResultOpened  : false,
        
        }
    },
}, initialState);

export default classTalk;
